module.exports = __webpack_public_path__ + "img/wissen.a9453053.png";